export const calcProgress = (
  totalQuestions: number,
  rightQuestions: number
) => {
  if (totalQuestions === 0) {
    return 0;
  } else return (rightQuestions / totalQuestions) * 100;
};
